import { setupMain } from './setup.js';
import * as directApi from './directApi.js';

const userEvent = {
    ...directApi,
    setup: setupMain
};

export { userEvent };
